export const sleepInfoConstant = {
    GET_BY_ID: 'SLEEP_REFERRAL_GET_BY_ID',
    GET_BY_PERSON: 'SLEEP_REFERRAL_GET_BY_PERSON',
    CHANGE: 'SLEEP_REFERRAL_CHANGE',
    SAVE_SUCCESS: 'SLEEP_REFERRAL_SAVE_SUCCESS',
    SELECT_CLINIC: 'SLEEP_REFERRAL_SELECT_CLINIC'
};
